export default {
  menu: {
    title: 'CONTACT',
    milano: 'MILANO {separator} VIA BORSI 9',
    spezia: 'LA SPEZIA {separator} VIA SAPRI 68',
    mail: 'Mail',
    careers: 'Unisciti al team',
  },
  newsletter: {
    title: 'Stay tuned',
    subtitle:
      'Non perdere nulla. Iscriviti alla nostra newsletter per rimanere aggiornato sui nostri eventi e sulle novità creative.',
    emailField: 'Email',
    emailPlaceholder: 'La tua email',
    cta: 'Iscriviti',
    gdpr: 'Ai sensi e per gli effetti del Reg. UE 2016/679 - GDPR do il consenso al trattamento dei miei dati personali come da <a target=“_blank” href=“/privacy-policy”>informativa sulla privacy</a>',
    gdprError: 'Required field',
    tracking:
      'Acconsento al tracciamento individuale di aperture e clic sulle newsletter, per ricevere contenuti più pertinenti. Posso revocare il consenso in qualsiasi momento dal Centro preferenze, senza disiscrivermi.',
    trackingDenied:
      'Non acconsento al tracciamento individuale: le mie aperture e i miei clic saranno conteggiati solo in forma anonima e aggregata.',
    successTitle: 'Grazie per esserti iscritto alla nostra newsletter!',
    resetCta: 'Nuova iscrizione',
  },
  bottom: {
    corporate:
      'Sun-TIMES srl - sede legale: Via Giosuè Borsi, 9, 20143 Milano MI {separator} Pra 3443 Rea 111454 {separator} PI 01231370113',
    cookie: 'Cookie',
    privacy: 'Privacy',
    whistleblowing: 'Whistleblowing',
  },
}
